import { AppUpdateInfo } from '@capawesome/capacitor-app-update';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonLabel,
  IonPage,
  IonTitle,
  IonToolbar,
  isPlatform,
} from '@ionic/react';
import { close } from 'ionicons/icons';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadAppStore, DownloadGooglePlay } from './AppDownload';
import './appstore.css';
interface AppUpdateAvailableProps {
  requiredUpdate?: boolean;
  onClose: () => void;
  appUpdateInfo?: AppUpdateInfo;
}

const AppUpdateAvailable = (props: AppUpdateAvailableProps): ReactElement => {
  const { onClose, requiredUpdate, appUpdateInfo } = props;
  const { i18n } = useTranslation();

  const title = requiredUpdate
    ? i18n.t('common:beacon_app_update_required')
    : i18n.t('common:beacon_app_update_available');

  return (
    <IonPage className="app-update-panel">
      <IonHeader>
        <IonToolbar>
          {requiredUpdate !== true && (
            <IonButtons slot={'start'}>
              <IonButton onClick={() => onClose()}>
                <IonIcon icon={close} size="large" />
              </IonButton>
            </IonButtons>
          )}
          <IonTitle>{title}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="ion-padding content-center ion-text-center">
          <IonLabel>
            <h2>{i18n.t('common:beacon_app_update_helper_text')}</h2>
          </IonLabel>
        </div>
        <div className="ion-padding content-center">
          {isPlatform('ios') ? <DownloadAppStore /> : <DownloadGooglePlay />}
        </div>
        <div className="ion-padding content-center">
          <IonLabel>
            <h2>
              {appUpdateInfo?.currentVersion} →{' '}
              {appUpdateInfo?.availableVersion}
            </h2>
          </IonLabel>
        </div>
      </IonContent>
    </IonPage>
  );
};

export { AppUpdateAvailable };
